import { render, staticRenderFns } from "./UpdateUserPassword.vue?vue&type=template&id=3b6ad5aa&scoped=true"
import script from "./UpdateUserPassword.vue?vue&type=script&lang=js"
export * from "./UpdateUserPassword.vue?vue&type=script&lang=js"
import style0 from "./UpdateUserPassword.vue?vue&type=style&index=0&id=3b6ad5aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6ad5aa",
  null
  
)

export default component.exports